import { Card, Label, TextInput } from 'flowbite-react'
import React, { useState } from 'react'
import { FaArrowRight } from 'react-icons/fa'
import { Link, useNavigate } from 'react-router-dom'
import * as styles from '../ForgotPassword/ForgotPassword.styles'
import Form from '../../components/Form/Form'
import CustomInput from '../../components/CustomInputs/CustomInput'
import CustomButton from '../../components/CustomButton/CustomButton'
import CustomLink from '../../components/CustomLinks/CustomLink'
import PublicLayout from '../../layouts/PublicLayout'
import client from '../../api/client'
import showToast from '../../components/CustomToast/toastHelper'

const ForgotPassword = () => {
    const [identifier, setIdentifier]= useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)
    const navigate = useNavigate()
    const payload:any ={
        identifier:identifier
    }

    const handleSubmit =async(e:any)=>{
        e.preventDefault()
        setLoading(true)
        try{
            const forgotPasswordResponse = await client.post("/subsidiary/dashboard/forgot-password",payload)
            
            if(forgotPasswordResponse.data.status =="success"){
                showToast(forgotPasswordResponse.data.message,"success")
                navigate('/reset-password',{state:{email:identifier}})
                setLoading(false)
            }
            else{
                setLoading(false)
                showToast(forgotPasswordResponse.data.message,"error")
            }
        }
        catch(err:any){
            console.error('Sign in error', err)
            setLoading(false)
            showToast(err.response.data.message,"error")
        }
    }
    return (
        <PublicLayout>
            <div className={styles.container}>
                <Card className={styles.card}>
                    <Form title="Forgotten Password" subtitle="Kindly enter your email address to reset your password">
                        <div>
                        <div>
                            <CustomInput value={identifier} onChange={(e)=>setIdentifier(e.target.value)} label='Email Address' name='email' />
                        </div>
                        <CustomButton onClick={handleSubmit} loading={loading} className={styles.button} text='Reset Password' icon={<FaArrowRight />} />

                        <div className={styles.buttomDiv}>
                            <p className={styles.buttomDivPara}>Already have an account?
                                <CustomLink className={styles.link} to="/login" text=" Login" />
                            </p>
                        </div>
                        </div>
                    </Form>

                </Card>

            </div>
        </PublicLayout>
    )
}

export default ForgotPassword
